import { useTranslation } from 'next-i18next'

export default function HeroFloatCards(): React.ReactElement {
  const { t } = useTranslation('abTestLanding')

  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 hidden md:block">
      <div className="absolute left-3/20 top-2/5">
        <div
          className="w-44 rounded-3 border border-white/80 bg-white/20 p-2
         text-white/80 shadow-ai-glow backdrop-blur-sm"
        >
          <p className="text-xxs font-semibold uppercase">{t('v4.hero.floatCard.aiTitle')}</p>
          <p className="mt-1 text-sm leading-relaxed">{t('v4.hero.floatCard.aiLine1')}</p>
          <p className="text-sm leading-relaxed">{t('v4.hero.floatCard.aiLine2')}</p>
        </div>
        <div className="-mt-6 ml-28 w-44 rounded-3 border border-white/80 bg-white/20 p-3 pb-5 text-white/90 backdrop-blur-sm">
          <p className="text-xxs font-semibold">{t('v4.hero.floatCard.solveTitle')}</p>
          <p className="mt-1 text-sm font-bold">{t('v4.hero.floatCard.equation')}</p>
          <p className="text-sm">{t('v4.hero.floatCard.answer')}</p>
        </div>
      </div>
    </div>
  )
}
